import { render, staticRenderFns } from "./LocksProcesso.vue?vue&type=template&id=39fed488&scoped=true&"
import script from "./LocksProcesso.vue?vue&type=script&lang=js&"
export * from "./LocksProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fed488",
  null
  
)

export default component.exports